module.exports = __webpack_public_path__ + "static/media/logo-white.8f081a9c.png";